/**
 * TwoPoint Portfolio Widget — Parent-side Entry Point
 * Embed as <script> on the host page to manage iframe height sync.
 *
 * Uses @repo/iframe-widget-core for shared iframe communication logic.
 */

import { createWidgetManager } from '@repo/iframe-widget-core/parent';

const manager = createWidgetManager({
  logPrefix: 'TwoPoint Portfolio Widget',
  idPrefix: 'twopoint-portfolio',
  iframeClass: 'twopoint-portfolio-iframe',
  wrapClass: 'twopoint-portfolio-iframe-wrap',
  styleId: 'twopoint-portfolio-widget-styles',
  scriptSrcMatch: 'twopoint-portfolio-widget',
});

export default manager;

if (typeof window !== 'undefined') {
  (window as any).TwoPointPortfolioWidget = manager;
  manager.autoInit();
}
